module.exports = __webpack_public_path__ + "static/homepage_header-7c9a6a219f70350d345a55d49b45c95e.png";